import pluralize from 'pluralize';
import React, { useMemo } from 'react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

import { palette } from '~/utils/colours';

export interface IconWithTooltipProps {
  id: string;
  faIcon: string;
  color?: string;
  tooltipText: string;
  className?: string | null;
}

export function IconWithTooltip({
  id,
  faIcon,
  color,
  tooltipText,
  className,
}: IconWithTooltipProps) {
  const tooltip = <Tooltip id={`tooltip-${id}`}>{tooltipText}</Tooltip>;

  return (
    <OverlayTrigger placement='bottom' overlay={tooltip}>
      <i className={`fas fa-${faIcon} ${className ?? ''}`} style={{ color }} />
    </OverlayTrigger>
  );
}

export interface IconProps {
  className?: string | null;
}

export interface WatchedIconProps extends IconProps {
  watchCount?: number;
}

export const Scheduled = ({ className }: IconProps) => (
  <IconWithTooltip
    className={className}
    id='scheduled'
    faIcon='clock'
    color={palette.golden}
    tooltipText='Scheduled'
  />
);

export const Delivery = ({ className }: IconProps) => (
  <IconWithTooltip
    className={className}
    id='delivery'
    faIcon='paper-plane'
    color={palette.tealishTwo}
    tooltipText='Delivered'
  />
);
export const Blocked = ({ className }: IconProps) => (
  <IconWithTooltip
    className={className}
    id='delivery'
    faIcon='paper-plane'
    color={palette.brownGrey}
    tooltipText='Blocked'
  />
);
export const Replied = ({ className }: IconProps) => (
  <IconWithTooltip
    className={className}
    id='replied'
    faIcon='comment-alt'
    color={palette.robinSEgg}
    tooltipText='Replied'
  />
);
export const Liked = ({ className }: IconProps) => (
  <IconWithTooltip
    className={className}
    id='liked'
    faIcon='heart'
    color={palette.darkishPink}
    tooltipText='Liked'
  />
);
export const Clicked = ({ className }: IconProps) => (
  <IconWithTooltip
    className={className}
    id='clicked'
    faIcon='mouse-pointer'
    color={palette.golden}
    tooltipText='Template CTA clicked'
  />
);
export const Opened = ({ className }: IconProps) => (
  <IconWithTooltip
    className={className}
    id='opened'
    faIcon='envelope-open'
    color={palette.fern}
    tooltipText='Opened'
  />
);

export const Watched = ({ watchCount, className }: WatchedIconProps) => {
  const tooltipText = useMemo(() => {
    if (watchCount != null) {
      return `Watched ${watchCount} ${pluralize('time', watchCount)}`;
    }

    return 'Watched';
  }, [watchCount]);

  return (
    <IconWithTooltip
      className={className}
      id='watched'
      faIcon='play-circle'
      color={palette.tealishThree}
      tooltipText={tooltipText}
    />
  );
};
